import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { useAuthHook } from "../hooks/useAuth";
import { ROUTES } from "../../../utils/constants";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthHook();

  if (loading) return null; // ✅ or a spinner if you want

  return isAuthenticated ? children : <Navigate to={ROUTES.LOGIN} />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
